import { coastEncounters } from './coast-encounters.js';
import { coastSites } from './coast-sites.js';
import { formationFor, type EncounterPost } from './formations.js';
export type { EncounterPost } from './formations.js';

/** Each crew's formation, generated from its roster around the site's authored route. */
export const coastPosts: Record<string, EncounterPost> = Object.fromEntries(coastEncounters.map(plan =>
  [plan.id, formationFor(coastSites.find(site => site.id === plan.id)!, plan.members)]));
